import React, { useState, useEffect, useCallback, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { getSerialWiseHistory } from '../../../redux/actions/salesLineDetail';
import { FaCircleInfo } from 'react-icons/fa6';
import { getAdjustedDocs } from '../../../redux/actions/salesInvoice';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
import LineItem from '../sales/Pages/SalesInvoiceMaster/LineItem';
import BillTerm from '../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as dynamicDropdown } from 'components/ui/DynamicDropdown';
import InputField from 'components/ui/InputField';
import SerialNumberModal from '../purchase/Pages/PurchaseInvoiceMaster/SerialNumberModal';
import CustomerVerifyModal from '../purchase/Pages/PurchaseInvoiceMaster/CustomerVerifyModal';
import TextareaField from 'components/ui/TextareaField';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import TakaForm from '../purchase/Pages/PurchaseInvoiceMaster/TakaForm';
import IssueToMill from '../purchase/Pages/PurchaseInvoiceMaster/IssueToMill';
import SelectTakaDetail from '../purchase/Pages/PurchaseInvoiceMaster/SelectTakaDetail';

import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useBusinessType, useAccount, useDaybook, useItem } from '../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import usePurchaseLastDaybook from 'hooks/usePurchaseLastDaybook';

// Actions
import { getStock } from '../../../redux/actions/salesLineDetail';
import { getAccount } from '../../../redux/actions/account';
import { getPaymentDaybook, getDaybookById, getDaybook } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../redux/actions/glGroup';
import {
   addPurchaseInvoice,
   updatePurchaseInvoice,
   getPurchaseInvoice,
   getPurchaseInvoices,
   deletePurchaseLineItem,
   emptyPurchase,
   getPrevAndNext,
   checkDocNo,
   getLastPurchaseDaybook,
   uploadPurchaseDocument,
} from '../../../redux/actions/purchaseInvoice';
import { getBillTerm } from '../../../redux/actions/billTerm';
import { getSetupFormat, setupFormatCustomQuery } from '../../../redux/actions/setupFormat';
import { getIssuesDocument } from '../../../redux/actions/issue';
import { getUsers } from '../../../redux/actions/user';
import { getFinancialYears } from '../../../redux/actions/dashboard';
import { getItemPrice } from '../../../redux/actions/salesInvoice';

// utils
import {
   removeDuplicates,
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getFinancialYear,
   getGstRate,
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash } from 'react-icons/fa';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import loaderAnimation from 'assets/img/auth/loding.gif';
import back from 'assets/img/nfts/back.svg';

import DeleteDialog from '../masters/components/DeleteDialog';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),
      partyNo: Yup.string().required('Party number is required').trim(),
      partyDate: Yup.date().required('Party date is required'),
      transactionAt: Yup.date()
         .required('Transaction date is required')
         .max(new Date(), 'Transaction date cannot be in the future'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number()
         .required('Basic amount is required')
         .min(0, 'Basic amount cannot be negative')
         .test(
            'is-decimal',
            'Amount cannot have more than 2 decimal places',
            (value) => !value || Number.isInteger(value * 100),
         ),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),

            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),
            // .test(
            //    'is-decimal',
            //    'Rate cannot have more than 2 decimal places',
            //    (value) => !value || Number.isInteger(value * 100),
            // ),

            qty1: Yup.number().required('Quantity is required').min(0, 'Quantity cannot be negative'),

            qty2: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            qty3: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),

            lineNumber: Yup.number()
               .required('Line number is required')
               .positive('Line number must be positive')
               .integer('Line number must be a whole number'),
         }),
      ),
});

const PurchaseInvoiceForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const {
      isOpen: isOpenIssueToMillModal,
      onOpen: onOpenIssueToMillModal,
      onClose: onCloseIssueToMillModal,
   } = useDisclosure();
   const { isOpen: isOpenTakaModal, onOpen: onOpenTakaModal, onClose: onCloseTakaModal } = useDisclosure();
   const { isOpen: isOpenVerifyModal, onOpen: onOpenVerifyModal, onClose: onCloseVerifyModal } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const {
      isOpen: isOpenTakaDetailModal,
      onOpen: onOpenTakaDetailModal,
      onClose: onCloseTakaDetailModal,
   } = useDisclosure();
   const {
      isOpen: isOpenPrintFormatModal,
      onOpen: onOpenPrintFormatModal,
      onClose: onClosePrintFormatModal,
   } = useDisclosure();
   const { lastPurchaseDaybook, setSelectedDaybookId: setDaybookId } = usePurchaseLastDaybook();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   const { items: itemData } = useItem();
   const { accounts: accountData } = useAccount();
   const { purchaseDaybooks: daybookData, paymentDaybooks: daybookPaymentData } = useDaybook();

   // all Selector
   // const itemData = useSelector((state) => state.item?.list ?? []);
   // const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   // const accountData = useSelector((state) => state?.account?.list);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.purchaseInvoice?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   // const daybookPaymentData = useSelector((state) => state.daybook?.paymentList);
   const selectedDaybook = useSelector((state) => state.daybook.single);
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const warehouseList = useSelector((state) => state.warehouse.list);
   // const companyData = useSelector((state) => state.company.single);
   const companyData = company;
   const targetGlGroup = glGroup.find((group) => group.code === 'E');
   const prints = useSelector((state) => state.setupPrint.list);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const issueDocument = useSelector((state) => state?.issue?.issueDocument);
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const salesManList = useSelector((state) => state.users.users || []);
   const pendingReceive = useSelector((state) => state.receiveInventory.getPendingReceiveInventories ?? []);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const [data, setData] = useState([]);
   const [invoiceImages, setInvoiceImages] = useState([]);
   const [selectedItem, setSelectedItem] = useState(null);
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);

   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: 0,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,

         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,

         stock: [],
         takaDetails: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,

         issueLineId: null,
         subHSNId: null,
         warehouseId: null,
         issuedDocumentId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
      };
   }, [company?.hsndata, company?.sacdata]);

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [deleteLineItemIdx, setDeleteLineItemIdx] = useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [lastItemId, setLastItemId] = useState(null);
   const [currentIndex, setCurrentIndex] = useState(null);
   const [isSameState, setIsSameState] = useState(null);
   const [paymentData, setPaymentData] = useState([]);
   const [voucher, setVoucher] = useState(null);
   const [itemStocks, setItemStocks] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [issuedDoc, setIssuedDoc] = useState([]);
   const [currentTakaDetails, setCurrentTakaDetails] = useState([]);
   const [issueData, setIssueData] = useState({});
   const [takaDetails, setTakaDetails] = useState([]);
   const [selectedTakaDetails, setSelectedTakaDetails] = useState([]);
   const [row, setRow] = useState({
      header: {
         daybookId: lastPurchaseDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         partyNo: '',
         partyDate: new Date().toISOString().split('T')[0],
         notes: '',
         representativeId: user?.id,
         incomeId: null,
      },
      lineItem: [initialLineItem],
   });
   const { id } = useParams();
   const toast = useToast();
   const dispatch = useDispatch();
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();
   const { businessTypes } = useBusinessType();

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const incomeRef = useRef(null);
   const brokerRef = useRef(null);
   const partyBillNoRef = useRef(null);
   const partyDateRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const notesRef = useRef(null);
   const wareHouseRef = useRef(null);
   const issueDocRef = useRef(null);
   const supplierRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const subamountRefs = useRef([]);
   const paymentRefs = useRef([]);
   const issueDocRefs = useRef([]);
   const refs = {
      warehouseRef,
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      issueDocRefs,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 11).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const vouchers = useMemo(() => salesInvoice?.vouchers ?? [], [salesInvoice?.vouchers]);

   useEffect(() => {
      if (user && user.isExpired) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      const purchaseInvoiceRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchaseinvoice
         : null;

      if (user && user?.isAdmin !== true) {
         if (window.location.pathname.includes('purchase/invoice/add') && purchaseInvoiceRight) {
            if (purchaseInvoiceRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('purchase/invoice/edit') && purchaseInvoiceRight) {
            if (purchaseInvoiceRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            if (!isLoading) {
               handleAskToVerifyCustomer();
            }
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [row, isLoading]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => amountRefs.current[i] || createRef());
   };

   const preparePaymentRowRefs = (count) => {
      paymentRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => paymentRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         const normalizedLineItems =
            row?.lineItem?.map((item) => ({
               ...item,
               qty2: item.qty2 ?? 0,
               qty3: item.qty3 ?? 0,
            })) ?? [];

         const updatedRow = {
            ...row,
            lineItem: normalizedLineItems,
         };
         await validationSchema.validate(updatedRow, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   const handleStockModalOnClick = useCallback(
      async (index, type) => {
         const selectedItemData = row.lineItem[Number(index)];
         const item = itemData.find((item) => item?.id?.toString() === selectedItemData?.itemId?.toString());
         if (user?.loginhistory?.companyId) {
            await dispatch(
               getStock({
                  itemId: Number(selectedItemData?.itemId),
                  companyId: Number(user?.loginhistory?.companyId),
               }),
            );
         }
         if (item && item.itemdetailtype === 1) {
            setLastItemId(selectedItemData.itemId);
            setStockList((prev) => prev.concat(selectedItemData?.stock));
            setItemStocks(
               selectedItemData?.stock?.map((item) => ({
                  id: item.id,
                  note1: item.note1,
                  serialNo: item?.serialNo,
                  serialNo2: item?.serialNo2,
                  barcode: item.barcode,
                  isOld: item.isOld,
                  itemId: selectedItemData.itemId,
                  itemName: selectedItemData.itemName,
                  warehouseId: item?.warehouseId,
               })),
            );
            setCurrentIndex(index);
            onOpenModal();
         } else if (type === 'purchaseinvoice') {
            setLastItemId(selectedItemData.itemId);
            setStockList((prev) => prev.concat(selectedItemData?.stock));
            setItemStocks(
               selectedItemData?.stock?.map((item) => ({
                  note1: item.note1,
                  serialNo: item?.serialNo,
                  serialNo2: item?.serialNo2,
                  warehouseId: item?.warehouseId,
                  barcode: item.barcode,
                  isOld: item.isOld,
                  itemId: selectedItemData.itemId,
                  itemName: selectedItemData.itemName,
               })),
            );
            setCurrentIndex(index);
            onOpenModal();
         }
         // else if (type === 'purchaseinvoice') {
         //    setLastItemId(selectedItemData.itemId);
         //    setStockList((prev) => prev.concat(selectedItemData?.stock));
         //    setItemStocks(
         //       selectedItemData?.stock?.map((item) => ({
         //          note1: item.note1,
         //          serialNo: item?.serialNo,
         //          serialNo2: item?.serialNo2,
         //         warehouseId: item?.warehouseId,
         //          barcode: item.barcode,
         //          isOld: item.isOld,
         //          itemId: selectedItemData.itemId,
         //          itemName: selectedItemData.itemName,
         //       })),
         //    );
         //    setCurrentIndex(index);
         //    onOpenModal();
         // }
         if (
            daybook &&
            daybook.getLineDetail &&
            selectedItemData.itemId &&
            selectedItemData.itemId > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            setCurrentIndex(index);
            setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);

            const itemData = row.lineItem[Number(index)];
            if (selectedItemData.issuedDocumentId && selectedItemData.issuedDocumentId > 0) {
               // const receiveDocument = pendingReceive.find((x) => x.item_id === itemData.itemId);
               setSelectedTakaDetails(itemData?.takaDetails);
               onOpenTakaDetailModal();
            } else {
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         dispatch,
         itemData,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaModal,
         row.lineItem,
         user?.loginhistory?.companyId,
      ],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };

      setDaybookId(Number(value));
      await dispatch(
         getBillTerm({
            daybookId: Number(value),
            ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
         }),
      );

      newRow.header[name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = async (name, value) => {
      if (name === 'accountId' && value !== null) {
         const newRow = { ...row };
         const id = value?.id ? value.id : value;
         newRow.header[name] = id;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
         if (daybook && daybook?.issuedaybookid && value) {
            await dispatch(getIssuesDocument({ accountId: value }));
         }
         if (value === '' && daybook && daybook?.issuedaybookid) {
            const lineItem = {
               typeOfSupply: 1,
               headerId: 1,
               gst: 0,
               netGst: 0,
               gstAmount: 0,
               itemId: null,
               lineNumber: 1,
               itemRate: 0,
               amount: 0,
               netAmount: 0,
               taxableAmount: 0,
               ratePer: 0,
               uomNoForRate: 0,
               salesprice1: 0,
               salesprice2: 0,
               salesprice3: 0,
               qty1: 0,
               qty2: 0,
               qty3: 0,
               hsnData: company?.hsndata,
               sacData: company?.sacdata,
               ratio: null,
               addLess1Percent: 0,
               addLess1Amount: 0,
               addLess2Percent: 0,
               addLess2Amount: 0,
               addLess3Percent: 0,
               addLess3Amount: 0,
               stock: [],
               takaDetails: [],
               unit: null,
               qUnitId1: null,
               qUnitId2: null,
               qUnitId3: null,
               issueLineId: null,
               subHSNId: null,
               warehouseId: null,
               issuedDocumentId: null,
               isDeleted: false,
               notes: '',
               remarks: '',
            };
            setRow((prev) => ({
               ...prev,
               lineItem: [lineItem],
            }));
            setIssuedDoc([]);
         }
      }
      if (name === 'accountId' && value === null) {
         const newRow = { ...row };
         const id = value?.id ? value.id : value;
         newRow.header[name] = id;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
      }

      if (name === 'warehouseId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         newRow.lineItem = newRow.lineItem.map((item) => ({
            ...item,
            [name]: value,
            stock: Array.isArray(item.stock)
               ? item.stock.map((stockItem) => ({
                  ...stockItem,
                  [name]: value,
               }))
               : [], // fallback if stock is not array
         }));
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }

      if (name === 'brokerId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }

      if (name === 'representativeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.representativeId'];
            return obj;
         });
      }

      if (name === 'incomeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.incomeId'];
            return obj;
         });
      }
   };

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData.find((item) => item.id.toString() === itemId.toString());
         if (selectedItem && selectedItem.itemdetailtype === 1) {
            setCurrentIndex(index);
            onOpenModal();
         }

         if (
            daybook &&
            daybook?.getLineDetail &&
            selectedItem &&
            selectedItem?.id > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            const itemData = row.lineItem[Number(index)];
            if (itemData?.issuedDocumentId && itemData?.issuedDocumentId > 0) {
               const purchaseDocument = pendingReceive.find((x) => x.item_id === itemId);

               const td = purchaseDocument?.takadetails?.map((i) => {
                  return {
                     ...i,
                     id: i.issue_line_detail_id,
                     quantity3: i.issued_qty3_taka_meters,
                     itenName: purchaseDocument.item_description,
                     itemId: purchaseDocument.item_id,
                     purchaseLineItemId: purchaseDocument.purchase_line_item_id,
                     issued_qty1: i.issued_qty1,
                  };
               });

               setTakaDetails(td);

               onOpenTakaDetailModal();
            } else {
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         itemData,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaModal,
         pendingReceive,
         row.lineItem,
      ],
   );

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
   };

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data?.items
               ?.filter((subdata) => subdata.item_id === selectedItem.itemId)
               ?.flatMap((subdata) => subdata?.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem]);

   const handleAdjustedDocs = () => {
      dispatch(
         getAdjustedDocs({
            companyId: user?.loginhistory?.companyId,
            spId: id,
            daybookId: row.header.daybookId,
            accountId: row.header.accountId,
            type: 'PURCHASE',
         }),
      );
      onOpenAdjustedDocs();
      const selectedDaybookData = daybookData.filter((item) => item.id === row.header.daybookId);
      setSelectedDaybookData(selectedDaybookData);
   };

   const handleItemPrice = useCallback(
      async (itemId, type) => {
         if (daybook?.partyItemWiseLastRate || daybook?.itemWiseLastRate) {
            const params = { itemId, companyId: company?.id, type };
            if (daybook?.partyItemWiseLastRate) {
               params.accountId = account?.id;
            }
            const res = await dispatch(getItemPrice(params));
            return res?.data?.itemPrice ?? '';
         }
      },
      [account?.id, company?.id, daybook?.itemWiseLastRate, daybook?.partyItemWiseLastRate, dispatch],
   );

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         const gstRate = getGstRate(value, newRow, header, idx);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      if (name === 'warehouseId') {
         newRow[header][idx][name] = value;
      }

      if (name === 'issuedDocumentId') {
         if (businessTypes?.businessType?.toUpperCase() === 'TEXTILE') {
            setCurrentIndex(idx);
            const purchaseDocument = pendingReceive.find((x) => x.item_id === Number(value));
            handleItemChange('itemId', purchaseDocument?.item_id, idx, "purchaseorder");
            if (purchaseDocument) {
               if (daybook && daybook.getLineDetail === false) {
                  const qty1 = Number(purchaseDocument?.balance_receive_qty1 ?? 0);
                  const qty3 = Number(purchaseDocument?.balance_receive_qty3_taka_meters ?? 0);

                  handleQtyChange('qty1', qty1, idx);
                  handleQtyChange('qty3', qty3, idx);
               }

               newRow[header][idx].issuedDocumentId = Number(value);
               newRow[header][idx].itemId = purchaseDocument?.item_id;
               setRow(newRow);
               handleStockModal(purchaseDocument?.item_id, idx);
            }
         }
      }
      if (name === 'itemId') {
         const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].unit = selectedItem?.rateperpurchaseid;
         setCurrentIndex(idx);
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, "purchaseorder");
         if (selectedItem?.purchaseprice) {
            // const itemRate = Number(selectedItem?.purchaseprice || 0);
            // const gstPercent = Number(newRow[header][idx].gst || 0);
            // const gstRate = itemRate * (1 + gstPercent / 100);
            const gstRate = getGstRate(selectedItem?.salesprice1, newRow, header, idx);
            newRow[header][idx].gstWithRate = gstRate;
         }
         const itemPrice = await handleItemPrice(value, 'purchase');
         const rate = getGstRate(itemPrice, newRow, header, idx);
         newRow[header][idx].gstWithRate = rate;
         dispatch(
            getStock({
               itemId: Number(value),
               companyId: user?.loginhistory?.companyId,
            }),
         );
         handleStockModal(value, idx);
         handleStockModalOnClick(idx);
         setLastItemId(Number(value));
      }
      const selectedDaybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      let subHsn;
      if (company?.setting?.applyGST && selectedDaybook?.applyGst) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const taxRate = parseFloat(subHsn?.gst) / 100;
            newRow[header][idx].gst = subHsn?.gst ?? 0;
            newRow[header][idx].subHSNId = subHsn?.id ?? 0;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            // Get the current basic amount
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;

            // Calculate addition and deduction totals based on the basic amount
            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });

            // Calculate net amount based on the basic amount
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);

            // Update the header amounts
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev.lineItem, { ...initialLineItem }],
      }));
   };

   const removeLineItem = (index, id) => {
      // if (id) {
      //    setDeleteLineItemId(id);
      //    setDeleteDialogOpen(true);
      //    setDeleteLineItemIdx(index);
      // } else {
      //    setRow((prev) => ({
      //       ...prev,
      //       lineItem: prev.lineItem.filter((_, i) => i !== index),
      //    }));
      // }

      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deletePurchaseLineItem(deleteLineItemId));
      if (deleteLineItemIdx >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== deleteLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      setDeleteLineItemIdx(null);
      setDeleteDialogOpen(false);
   };

   const removeStock = useCallback(
      (stock) => {
         // setSelectedStocks((prev) => {
         //    const updatedStocks = prev.filter((e) => e.serialNo !== stock.serialNo);
         //    return updatedStocks;
         // });

         const updatedLineItem = row?.lineItem?.map((item, idx) => {
            const selectedItem = itemData.find((i) => i.id === item.itemId);
            const stockData = item.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...item, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...item, stock: stockData, qty1: qty1 };
            }

            return item;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, row.lineItem, itemData], // Added missing dependencies
   );

   const handleEditValues = useCallback(() => {
      if (id && salesInvoice) {
         setRow({
            header: {
               daybookId: salesInvoice.daybookId,
               docno: salesInvoice.docno,
               transactionAt: salesInvoice.transactionAt
                  ? moment(salesInvoice.transactionAt).local().format('YYYY-MM-DD')
                  : '',
               dueAt: salesInvoice.dueAt ? new Date(salesInvoice.dueAt).toISOString().split('T')[0] : '',
               dueDays: salesInvoice.dueDays,
               accountId: salesInvoice.accountId,
               basicAmount: salesInvoice.basicAmount,
               netAmount: salesInvoice.netAmount,
               partyNo: salesInvoice.partyNo,
               partyDate: salesInvoice.partyDate ? new Date(salesInvoice.partyDate).toISOString().split('T')[0] : '',
               notes: salesInvoice.notes,
               brokerId: salesInvoice.brokerId,
               representativeId: salesInvoice.representativeId,
               warehouseId: salesInvoice.warehouseId,
               incomeId: salesInvoice.incomeId,
            },
            lineItem: salesInvoice?.lineitems?.map((item, index) => {
               return {
                  ...item,
                  itemRate: item.itemRate?.toString(),
                  amount: item.amount,
                  typeOfSupply: Number(item.typeOfSupply),
                  netAmount: item.netAmount,
                  taxableAmount: item.taxableAmount,
                  ratio: item.ratio,
                  addLess1Percent: item.addLess1Percent,
                  addLess1Amount: item.addLess1Amount,
                  addLess2Percent: item.addLess2Percent,
                  addLess2Amount: item.addLess2Amount,
                  addLess3Percent: item.addLess3Percent,
                  addLess3Amount: item.addLess3Amount,
                  gst: item.gstPercent,
                  // unit: itemData.find((x) => x.id === item.itemId)?.rateperpurchaseid,
                  unit: item.ratePer,
                  isDeleted: false,
                  notes: item.notes ? item.notes : '',
                  remarks: item.remarks ? item.remarks : '',
                  gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  stock: item?.purchaseLineDetail
                     ?.filter((a) => a.serialNo !== '' && a.serialNo !== null && a.serialNo !== undefined)
                     .map((stock) => {
                        const {
                           id,
                           isOld,
                           itemId,
                           barcode,
                           itemName,
                           serialNo,
                           quantity1,
                           quantity2,
                           quantity3,
                           serialNo2,
                           specifications,
                           lineItemId,
                           warehouseId,
                           warehouseName,
                           issueLineDetailId,
                        } = stock;
                        return {
                           id: id,
                           isOld: isOld,
                           itemId: itemId,
                           barcode: barcode,
                           itemName: itemName,
                           serialNo: serialNo,
                           serialNo2: serialNo2,
                           specifications: specifications,
                           warehouseId: warehouseId,
                           warehouseName: warehouseName,
                           issueLineDetailId: issueLineDetailId,
                           lineItemId: lineItemId,
                           quantity2: quantity2,
                           quantity3: quantity3,
                           quantity1: quantity1,
                           pcs: quantity1,
                        };
                     }),
                  takaDetails: item.purchaseLineDetail.map((x) => {
                     return { quantity3: x.quantity3 };
                  }),
               };
            }),
         });

         const initialBillTerms = billTermData?.map((term) => {
            const billTerm = salesInvoice.purchasebillterms?.find((billTerm) => billTerm.billTermId === term.id);
            if (billTerm) {
               return {
                  id: billTerm?.id,
                  billTermId: term.id,
                  percentage: billTerm?.percentage || 0,
                  amount: billTerm?.amount || 0,
               };
            } else {
               return {
                  billTermId: term.id,
                  percentage: 0,
                  amount: 0,
               };
            }
         });
         setBillTerms(initialBillTerms);
      }
   }, [dispatch, id, salesInvoice, billTermData?.length]);
   //billTermData, dispatch, hasFetchedAccount, id, salesInvoice

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => ({
            ...prev,
            [header]: {
               ...prev[header],
               dueAt: moment().add(Number(value), 'days').format('YYYY-MM-DD'),
            },
         }));
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const saveData = _.debounce(
      async () => {
         const isValid = await validateForm();

         if (isValid) {
            setIsLoading(true);
            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  docno: row.header?.docno?.toString()?.trim(),
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  voucherId: voucher,
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  daybookId: Number(row.header.daybookId),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  partyNo: row.header.partyNo,
                  // partyDate: formatDate(row.header.partyDate),
                  partyDate: moment(row.header.partyDate).format('YYYY-MM-DD'),
                  transactionAt: moment(row.header.transactionAt).format('YYYY-MM-DD'),
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  warehouseId:
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : null,
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  gstTxnType: getGstTaxType(company, account, 'purchase'),
                  gstSubTxnType: getGstSubTaxType(company, account, 'purchase'),
                  assesseType: company?.assesseType ? company?.assesseType : 0,
                  distance: company?.distanceKM ? company?.distanceKM : 0,
                  brokerId: row.header.brokerId || null,
                  notes: row.header.notes || null,
                  representativeId: row.header.representativeId || null,
                  incomeId: row.header.incomeId || null,
               },
               lineItem: row?.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());
                  const finalWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                              : item.warehouseId
                           : companyData?.setting?.warehouseWishStock === true && lineDetailview === true
                              ? item?.itemId && selectedItem?.itemdetailtype !== 1
                                 ? item.warehouseId === null
                                    ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                                    : item.warehouseId
                                 : null
                              : null;

                  const finalStockWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                              : item.warehouseId
                           : companyData?.setting?.warehouseWishStock === true && lineDetailview === true
                              ? item.warehouseId === null
                                 ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                                 : item.warehouseId
                              : null;
                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,
                     // ratePer: selectedItem.rateperpurchaseid ? Number(selectedItem.rateperpurchaseid) : 0,
                     // uomNoForRate:
                     //    selectedItem?.uqcid1 === selectedItem?.rateperpurchaseid
                     //       ? 1
                     //       : selectedItem?.uqcid2 === selectedItem?.rateperpurchaseid
                     //       ? 2
                     //       : selectedItem?.uqcid3 === selectedItem?.rateperpurchaseid
                     //       ? 3
                     //       : 1,

                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem?.rateperpurchaseid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1) : 0,
                     qty2: item.qty2 ? Number(item.qty2) : 0,
                     qty3: item.qty3 ? Number(item.qty3) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     issueLineId: item.issueLineId,
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     stock:
                        item.stock?.length > 0
                           ? item.stock.map((s) => ({
                              ...s,
                              itemId: item.itemId,
                              warehouseId: finalStockWarehouse !== null ? finalStockWarehouse : s.warehouseId,
                              specifications: s.id ? s.specifications : null,
                              returnStatus: undefined,
                              warehouseName: undefined,
                              purchaseStatus: undefined,
                           }))
                           : [],
                     subHSNId: item.subHSNId ?? null,
                     takaDetails:
                        item?.takaDetails?.length > 0
                           ? item?.takaDetails
                              .filter((x) => x?.mts > 0 || x?.quantity3 > 0)
                              .map((a) => {
                                 return {
                                    issueLineDetailId: a.issueLineDetailId,
                                    notes1: a.remarks ? a.remarks ?? '' : a.notes1 ?? '',
                                    RQuantity1: a.RQuantity1 ? a.RQuantity1 : 0,
                                    RQuantity2: a.RQuantity2 ? a.RQuantity2 : 0,
                                    RQuantity3: a.usedMeter && a.usedMeter > 0 ? a.usedMeter : a.RQuantity3,
                                    quantity1: a.quantity1 ? a.quantity1 : 0,
                                    quantity2: a.quantity2 ? a.quantity2 : 0,
                                    quantity3: a.mts && a.mts > 0 ? a.mts : a.quantity3,
                                 };
                              })
                           : [],
                     warehouseId: finalWarehouse,
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  };
               }),
               purchaseBillTerms: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
               payments: paymentData.map((payment) => {
                  let data = {};
                  if (payment.id && payment.id > 0) data.id = payment.id;
                  if (payment.outAdjustmentId && payment.outAdjustmentId > 0)
                     data.outAdjustmentId = payment.outAdjustmentId;
                  data.daybookId = Number(payment.daybookId);
                  data.amount = Number(payment.amount);
                  return data;
               }),
               // payments: paymentData?.map((payment) => ({
               //    ...(payment.id && { id: payment.id }),
               //    ...(payment.outAdjustmentId && { outAdjustmentId: payment?.outAdjustmentId }),
               //    daybookId: Number(payment.daybookId),
               //    amount: Number(payment.amount),
               // })),
            };
            let res;
            if (id) {
               res = await dispatch(updatePurchaseInvoice(payload));
            } else {
               res = await dispatch(addPurchaseInvoice(payload));
            }

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1 && invoiceImages?.length > 0) {
               const formData = new FormData();
               console.log('save data', res.data);
               formData.append('id', res?.data?.id);
               invoiceImages.forEach((imgObj) => {
                  if (!imgObj.isExisting && imgObj.file) {
                     formData.append('bill', imgObj.file);
                  }
               });

               const response = await dispatch(uploadPurchaseDocument(formData));

               if (response?.code === 1) {
                  setInvoiceImages([]);
               }
            }

            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }
               if (daybook?.onlinePrinting) {
                  if (daybook?.askBeforePrint) {
                     Swal.fire({
                        title: 'Do you want to Print Document?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        cancelButtonColor: '#d33',
                        confirmButtonColor: '#3085d6',
                     }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                           if (daybook?.printingSettings === 0) {
                              await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Purchase Invoices',
                                 }),
                              );

                              const defaultFormat = prints.find((a) => a.isDefault);
                              if (defaultFormat) {
                                 const result = await dispatch(
                                    setupFormatCustomQuery({
                                       query: defaultFormat?.PrintFormat?.query,
                                    }),
                                 );
                                 if (result && result?.data && result?.data?.length > 0) {
                                    const html = injectDataIntoHtml(defaultFormat?.PrintFormat?.html, result?.data);
                                    handleReset();
                                    handlePrintClick(
                                       {},
                                       html,
                                       defaultFormat?.PrintFormat?.css,
                                       navigate,
                                       '/admin/purchase/invoice',
                                    );
                                 }
                              }
                           } else {
                              handleReset();
                              onOpenPrintFormatModal();
                           }
                        }

                        if (result.isDismissed) {
                           dispatch(emptyPurchase());
                           setVoucher(null);
                           await dispatch(
                              getPurchaseInvoices({
                                 page: 1,
                                 limit: 10,
                                 companyId: user?.loginhistory?.companyId,
                                 sortBy: 'id',
                                 sortOrder: 'desc',
                              }),
                           );
                           localStorage.removeItem('daybook');
                           localStorage.removeItem('accountId');
                           setIsLoading(false);
                           handleReset();
                           navigate('/admin/purchase/invoice');
                           return;
                        }
                     });
                     return;
                  }
               }

               if (
                  businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                  daybook?.allowAutoIssue &&
                  daybook?.isGrayPurchase
               ) {
                  // onOpenIssueToMillModal();

                  Swal.fire({
                     title: 'Do you want to Send to Mill?',
                     showCancelButton: true,
                     confirmButtonText: 'Yes',
                     cancelButtonText: 'No',
                     cancelButtonColor: '#d33',
                     confirmButtonColor: '#3085d6',
                  }).then(async (result) => {
                     /* Read more about isConfirmed, isDenied below */
                     if (result.isConfirmed) {
                        setIssueData(res.data);
                        onOpenIssueToMillModal();
                        setIsLoading(false);
                        navigate(`/admin/purchase/invoice/edit/${res?.data?.id}`);
                        return;
                     }

                     if (result.isDismissed) {
                        dispatch(emptyPurchase());
                        setVoucher(null);
                        await dispatch(
                           getPurchaseInvoices({
                              page: 1,
                              limit: 10,
                              companyId: user?.loginhistory?.companyId,
                              sortBy: 'id',
                              sortOrder: 'desc',
                           }),
                        );
                        localStorage.removeItem('daybook');
                        localStorage.removeItem('accountId');
                        setIsLoading(false);
                        handleReset();
                        navigate('/admin/purchase/invoice');
                        return;
                     }
                  });

                  setIsLoading(false);
                  return;
               }
            }

            if (res?.code === 1) {
               dispatch(emptyPurchase());
               setVoucher(null);
               await dispatch(
                  getPurchaseInvoices({
                     page: 1,
                     limit: 10,
                     companyId: user?.loginhistory?.companyId,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               localStorage.removeItem('daybook');
               localStorage.removeItem('accountId');
               setPaymentData([]);
               setIsLoading(false);
               handleReset();
               navigate('/admin/purchase/invoice');
            }
            setIsLoading(false);
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         }
      },
      500,
      { leading: true, trailing: true },
   );

   const handleSubmit = useCallback(async () => {
      setIsLoading(true);
      const now = Date.now();
      if (now - lastClick.current < 1000) return;
      lastClick.current = now;

      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);
      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         companyId: user?.loginhistory?.companyId,
      };
      if (id) data.id = Number(id);
      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               newRow.header.partyNo = company?.setting?.partynoequaltodocno
                  ? res.data?.newDocNo.toString()
                  : newRow.header.partyNo;
               setRow(newRow);
               await saveData();
            }

            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else {
         await saveData();
      }
   }, [dispatch, id, row, saveData, user?.loginhistory?.companyId]);

   // const handleStock = useCallback(
   //    (rows) => {
   //       let newData = [];
   //       if (id) {
   //          newData = rows?.map((row) => {
   //             return {
   //                id: row.id,
   //                serialNo: row.serialNo,
   //                serialNo2: row.serialNo2,
   //                barcode: row.barcode,
   //                note1: row.note1 ?? '',
   //                isOld: row.isOld,
   //                itemId: lastItemId,
   //                itemName: itemData?.find((a) => a.id === lastItemId)?.name,
   //                warehouseId: row.warehouseId,
   //             };
   //          });
   //       } else {
   //          newData = rows?.map((i) => ({
   //             id: i.id,
   //             serialNo: i.serialNo,
   //             serialNo2: i.serialNo2,
   //             barcode: i.barcode,
   //             note1: i.note1 ?? '',
   //             isOld: i.isOld,
   //             itemId: lastItemId,
   //             itemName: itemData?.find((a) => a.id === lastItemId)?.name,
   //             warehouseId: i.warehouseId,
   //          }));
   //       }

   //       setRow((prev) => ({
   //          ...prev,
   //          lineItem: prev?.lineItem?.map((item, idx) => {
   //             if (currentIndex === idx) {
   //                const selectedItem = itemData?.find((a) => a.id.toString() === item.itemId.toString());

   //                // const lineItem =
   //                //    selectedItem && selectedItem.salesprice1
   //                //       ? selectedItem.salesprice1
   //                //       : salesInvoice?.lineitems[currentIndex]?.itemRate;

   //                // const stockData = id ? newData : [...item.stock, ...newData];
   //                // const stockData = id && id > 0 ? [...(item.stock || []), ...newData] : newData;
   //                const stockData = id ? newData : newData;
   //                const stocks = removeDuplicates(stockData, 'serialNo');
   //                if (stocks?.length > 0) handleQtyChange('qty1', stocks?.length, idx);
   //                return {
   //                   ...item,
   //                   stock: selectedItem?.itemdetailtype === 1 ? stocks : 0,
   //                   qty1: selectedItem?.itemdetailtype === 1 ? stocks?.length : '',
   //                   // itemRate: lineItem,
   //                };
   //             }
   //             return item;
   //          }),
   //       }));
   //       onCloseModal();
   //    },
   //    [currentIndex, handleQtyChange, id, itemData, lastItemId, onCloseModal],
   //    // currentIndex, handleQtyChange, id, itemData, lastItemId, onCloseModal, salesInvoice?.lineitems
   // );

   const handleStock = useCallback(
      (rows) => {
         let newData = rows?.map((row) => ({
            id: row.id,
            serialNo: row.serialNo,
            serialNo2: row.serialNo2,
            barcode: row.barcode,
            note1: row.note1 ?? '',
            isOld: row.isOld,
            itemId: lastItemId,
            itemName: itemData?.find((a) => a.id === lastItemId)?.name,
            warehouseId: row.warehouseId,
         }));

         const newRow = { ...row };
         newRow.lineItem = newRow?.lineItem?.map((item, idx) => {
            console.log('linedetail data', currentIndex, idx);
            if (currentIndex === idx) {
               const selectedItem = itemData?.find((a) => a.id.toString() === item.itemId.toString());
               const existingStock = Array.isArray(item.stock) ? item.stock : [];
               // const stockData = [...existingStock, ...newData];
               const stockData = newData;
               const stocks = removeDuplicates(stockData, 'serialNo');
               if (stocks?.length > 0) handleQtyChange('qty1', stocks?.length, idx);

               return {
                  ...item,
                  stock: selectedItem?.itemdetailtype === 1 ? stocks : [],
                  qty1: selectedItem?.itemdetailtype === 1 ? stocks?.length : '',
               };
            }
            return item;
         });

         setRow(newRow);
         onCloseModal();
      },
      [currentIndex, handleQtyChange, itemData, lastItemId, onCloseModal, row],
   );

   const handlePaymentOnChange = useCallback(
      (e, index) => {
         const { name, value } = e.target;
         const newPaymentData = [...paymentData];
         newPaymentData[index][name] = value;
         setPaymentData(newPaymentData);
      },
      [paymentData],
   );

   const handlePayment = useCallback(() => {
      if (daybookPaymentData?.length > 0) {
         const payment = daybookPaymentData?.map((payment) => {
            return { daybookName: payment.name, daybookId: payment.id, account: 0 };
         });
         setPaymentData(payment);
      }
   }, [daybookPaymentData?.length]);

   const handleAskToVerifyCustomer = useCallback(async () => {
      const isValid = await validateForm();
      if (isValid) {
         if (selectedDaybook?.isAskToAllow) {
            onOpenVerifyModal();
         } else {
            handleSubmit();
         }
      } else {
         toast({
            title: 'Validation Error',
            description: getFirstErrorMessage(errors),
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   }, [errors, handleSubmit, onOpenVerifyModal, selectedDaybook?.isAskToAllow, toast, validateForm]);

   const handleReset = useCallback(async () => {
      console.log('reset...');
      const initialRow = {
         header: {
            daybookId: lastPurchaseDaybook?.daybookId || '',
            docno: '',
            transactionAt: new Date().toISOString().split('T')[0],
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            partyNo: '',
            partyDate: new Date().toISOString().split('T')[0],
            notes: '',
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getPaymentDaybook({
               isPayment: true,
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
      handlePayment();
      // setSelectedStocks([]);
      setBillTerms([]);
      await dispatch(emptyPurchase());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, handlePayment, initialLineItem, lastPurchaseDaybook?.daybookId, shouldSendCompanyIdDaybook, user]);

   const getPurchaseInvoiceData = useCallback(() => {
      if (id) dispatch(getPurchaseInvoice(id));
   }, [dispatch, id]);

   const getData = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         // await dispatch(
         //    getAllDaybooks({
         //       type: 11,
         //       companyId: Number(user?.loginhistory?.companyId),
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getPaymentDaybook({
         //       isPayment: true,
         //       companyId: user?.loginhistory?.companyId,
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getAccount({
         //       compId: Number(user?.loginhistory?.companyId),
         //       accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
         //       ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         await dispatch(getUsers());
         // await dispatch(
         //    getItem({
         //       companyId: user?.loginhistory?.companyId,
         //       sortBy: 'name',
         //       sortOrder: 'asc',
         //       ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      setIsPageLoading(false);
   }, [dispatch, user]);

   const getIssueDate = useCallback(async () => {
      if (daybook && daybook?.issuedaybookid) {
         await dispatch(getIssuesDocument());
      }
   }, [daybook, dispatch]);

   const setLineItem = useCallback(() => {
      if (daybook && daybook?.issuedaybookid && issuedDoc?.length > 0) {
         const lineItem = issueDocument
            .filter((x) => issuedDoc.includes(x.issue_linedetail_id))
            .map((i) => {
               const item = itemData.find((x) => x.id === i.itemId);
               return {
                  itemId: i.itemId,
                  qty1: i.qty1 ?? 0,
                  qty2: i.qty2 ?? 0,
                  qty3: i.qty3 ?? 0,
                  itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                  amount: i.amount,
                  netAmount: i.netAmount,
                  gstPercent: i.gstPercent,
                  addLess1Percent: i.addLess1Percent,
                  addLess1Amount: i.addLess1Amount,
                  addLess2Percent: i.addLess2Percent,
                  addLess2Amount: i.addLess2Amount,
                  addLess3Percent: i.addLess3Percent,
                  addLess3Amount: i.addLess3Amount,
                  lineNumber: i.lineNumber,
                  issueLineId: i.issue_lineitem_id,
                  isDeleted: false,
                  stock:
                     item?.itemdetailtype === 1
                        ? [
                           {
                              serialNo: i.issued_serial_no,
                              serialNo2: i.issued_serial_no2,
                              barcode: i.barcode,
                              note1: i.note1,
                              isOld: i.isOld,
                              itemId: i.itemId,
                              itemName: i.itemName,
                              stockId: i.stockId,
                              issueLineDetailId: i.issue_linedetail_id,
                           },
                        ]
                        : [],
               };
            });
         setRow((prev) => ({
            ...prev,
            lineItem: lineItem,
         }));
      }
   }, [daybook, issueDocument?.length, issuedDoc, itemData?.length]);

   const handleTakaDetails = useCallback(
      (takaDetails) => {
         takaDetails = takaDetails
            ?.filter((q) => q.qty > 0)
            ?.map((t) => ({
               quantity1: 1,
               quantity2: 0,
               quantity3: t.qty ? Number(t.qty) : 0,
               notes1: '',
               issueLineDetailId: null,
               RQuantity1: 0,
               RQuantity2: 0,
               RQuantity3: 0,
            }));
         const totalTaka = takaDetails?.reduce((acc, item) => acc + Number(item?.quantity3 || 0), 0);
         setRow((prev) => ({
            ...prev,
            lineItem: prev?.lineItem?.map((item, idx) => {
               if (currentIndex === idx) {
                  const selectedItem = itemData.find((i) => i.id === item.itemId);
                  const unit = item.unit ?? selectedItem.rateperpurchaseid;
                  const qty1 = takaDetails?.length > 0 ? takaDetails?.length : 0;
                  const qty2 = selectedItem?.defaultcut > 0 ? Number(selectedItem?.defaultcut) : 0;
                  const qty3 = totalTaka;
                  handleQtyChange('qty3', qty3, idx);
                  return {
                     ...item,
                     qty1: qty1,
                     qty2: qty2,
                     qty3: qty3,
                     unit: unit,
                     takaDetails: [...takaDetails, { itemId: item.itemId }],
                  };
               }
               return item;
            }),
         }));
      },
      [currentIndex, handleQtyChange, itemData?.length],
   );

   const handleSaveTakaDetail = useCallback(
      (data) => {
         setRow((prevRow) => {
            const updatedLineItems = prevRow.lineItem.map((item, idx) => {
               if (idx === currentIndex) {
                  const selectedTakaDetail = data.filter((a) => a.mts > 0);
                  const totalTakaDetails = selectedTakaDetail.reduce((acc, item) => acc + Number(item?.mts || 0), 0);
                  return {
                     ...item,
                     qty1: selectedTakaDetail?.length,
                     qty3: totalTakaDetails,
                     takaDetails: data,
                  };
               }
               return item;
            });

            return {
               ...prevRow,
               lineItem: updatedLineItems,
            };
         });
      },
      [currentIndex],
   );

   // get default list
   useEffect(() => {
      if (user && !user?.packageData?.[0]?.purchase_invoice) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      getData();
   }, [getData]);

   useEffect(() => {
      getIssueDate();
   }, [getIssueDate]);

   useEffect(() => {
      setLineItem();
      return () => { };
   }, [setLineItem]);

   useEffect(() => {
      if (row.header.daybookId || lastPurchaseDaybook?.daybookId) {
         const daybookId = row.header.daybookId ? row.header.daybookId : lastPurchaseDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastPurchaseDaybook?.daybookId, row.header.daybookId]);

   // edit data by id
   useEffect(() => {
      getPurchaseInvoiceData();
   }, [getPurchaseInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      handleEditValues();
   }, [handleEditValues]);

   // set last sale daybook
   useEffect(() => {
      if (!id) {
         if (lastPurchaseDaybook && lastPurchaseDaybook.docno) {
            const currentDocNo = String(lastPurchaseDaybook.docno ?? 0);
            const nextDocNo =
               salesInvoice?.daybookId === lastPurchaseDaybook?.daybookId
                  ? salesInvoice?.docno
                  : (parseInt(currentDocNo) + 1).toString() ?? '1';
            // const nextDocNo = (parseInt(currentDocNo) + 1).toString() ?? '1';

            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  daybookId: lastPurchaseDaybook.daybookId,
                  docno: nextDocNo,
                  partyNo: company?.setting?.partynoequaltodocno ? nextDocNo : '',
               },
               lineItem: prev?.lineItem?.map((item) => {
                  return {
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  };
               }),
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  docno: '1',
                  partyNo: company?.setting?.partynoequaltodocno ? '1' : '',
               },
               lineItem: prev?.lineItem?.map((item) => {
                  return {
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  };
               }),
            }));
         }
      }
   }, [company?.setting?.partynoequaltodocno, daybook?.typeOfSupply, id, lastPurchaseDaybook]);

   useEffect(() => {
      if (daybookId) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const flattenedStocks = row?.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((item) =>
            item?.stock
               ?.map((s) => {
                  const changeItem = itemData.find((i) => i.id === item.itemId);
                  if (!item.itemId) return null;
                  if (item.itemId !== s.itemId) return null;
                  return { ...s, itemId: item.itemId, itemName: changeItem?.name };
               })
               .filter(Boolean),
         );
      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow?.lineItem?.map((item, index) => {
            const changeItem = itemData.find((i) => i.id === item?.itemId);
            return {
               ...item,
               stock: item?.stock
                  ?.map((s) =>
                     item.itemId === s?.itemId ? { ...s, itemId: item?.itemId, itemName: changeItem?.name } : null,
                  )
                  .filter(Boolean),
            };
         }),
      }));

      setSelectedStocks(flattenedStocks?.length > 0 ? flattenedStocks : null);
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      setStockList(stocks);
   }, [stocks]);

   useEffect(() => {
      handlePayment();
   }, [handlePayment]);

   useEffect(() => {
      if (row.header.daybookId && user && user?.loginhistory?.companyId) {
         const daybookById = {
            id: Number(row.header.daybookId), // id must be number
            compId: String(user?.loginhistory?.companyId), // compId must be string
         };
         dispatch(getDaybookById(daybookById));
      }
   }, [dispatch, row.header.daybookId, user]);

   useEffect(() => {
      if (!id || vouchers?.length === 0 || daybookPaymentData?.length === 0) return;

      setPaymentData((prevPaymentData) =>
         prevPaymentData.map((payment) => {
            const matchingVoucher = vouchers.find((voucher) => voucher.daybookId === payment.daybookId);

            return {
               ...payment,
               id: matchingVoucher?.id ?? null,
               amount: matchingVoucher?.amount ?? 0,
               outAdjustmentId: matchingVoucher?.outAdjustmentId ?? null,
            };
         }),
      );
   }, [id, vouchers, daybookPaymentData]);

   useEffect(() => {
      prepareRowRefs(row?.lineItem?.length);
   }, [row?.lineItem?.length]);

   useEffect(() => {
      prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   useEffect(() => {
      preparePaymentRowRefs(paymentData?.length);
   }, [paymentData?.length]);

   // useEffect(() => {
   //    const timer = setTimeout(() => {
   //       setIsPageLoading(false);
   //    }, 5000);

   //    return () => clearTimeout(timer);
   // }, [row.header.daybookId]);

   useEffect(() => {
      if (!id) {
         if (row.header.daybookId) {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }
      }
   }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   const filteredDaybooks = daybookData.filter((item) => item.type === 11);
   const daybookbalance = filteredDaybooks.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               // Focus docnoRef if not already focused
               docNoRef.current?.focus();
            } else {
               // If already focused, go back
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 3
               ? true
               : false
            : false;

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (herderview === true) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  warehouseId: selectdaybookdata?.wareHouseId
                     ? selectdaybookdata?.wareHouseId
                     : companyData?.setting?.warehouseId
                        ? companyData?.setting?.warehouseId
                        : 1,
               },
            }));
         }
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId === null
                           ? selectdaybookdata?.wareHouseId
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, JSON.stringify(row.lineItem)]);

   return (
      <>
         <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            // mt="-145px"
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex alignItems="center" gap={2}>
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }} // Navigate to the previous page
                              style={{ cursor: 'pointer' }} // Ensure it's clickable
                           ></img>
                           {id ? 'Update' : 'Add'} Purchase Order
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance: ₹{Math.abs(daybookbalance)?.toFixed(2)})
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    daybookData.filter((item) => item.type === 11),
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 11,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 <InputField
                                    ref={docNoRef}
                                    type="text"
                                    name="docno"
                                    label="Document Number"
                                    value={row.header.docno}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={async (e) => {
                                       if (e.key === 'PageUp') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastPurchaseDaybook?.id)
                                                navigate(`/admin/purchase/invoice/edit/${lastPurchaseDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.prev) {
                                                navigate(`/admin/purchase/invoice/edit/${res.prev}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/purchase/invoice/add`);
                                             }
                                          }
                                          return;
                                       }
                                       if (e.key === 'PageDown') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastPurchaseDaybook?.id)
                                                navigate(`/admin/purchase/invoice/edit/${lastPurchaseDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.next) {
                                                navigate(`/admin/purchase/invoice/edit/${res.next}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/purchase/invoice/add`);
                                             }
                                          }
                                          return;
                                       }
                                       handleKeyDown(e, transactionAtRef, daybookRef);
                                    }}
                                    autoFocus={id > 0 ? true : false}
                                 />
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Grid
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%"
                                       gap={5}>
                                       <Flex gap={5} justifyContent="space-between">
                                          {account.mobile ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={phone}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Phone Icon"
                                                />
                                                {account.mobile}
                                             </GridItem>
                                          ) : null}

                                          {account.email ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Email}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Email Icon"
                                                />
                                                {account.email}
                                             </GridItem>
                                          ) : null}

                                          {account.panNo ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={panno}
                                                   alt="editicon"
                                                   boxSize="22px"
                                                   mr={2}
                                                   title="Pan no Icon"
                                                />
                                                {account.panNo}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                       <Flex gap={5} alignItems="start">
                                          {account.addressJson?.length > 0 ? (
                                             <GridItem display="flex" alignItems="center" maxHeight="50%">
                                                <Image
                                                   src={map}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Billing address Icon"
                                                />
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index}>{address.address1}</Text>
                                                ))}
                                             </GridItem>
                                          ) : null}

                                          <Grid gap={5}>
                                             {account.gstRegNo ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={gstno}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="gst Icon"
                                                   />
                                                   {account.gstRegNo}
                                                </GridItem>
                                             ) : null}
                                             {account.brokername ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Brokername}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Broker name Icon"
                                                   />
                                                   {account.brokername}
                                                </GridItem>
                                             ) : null}

                                             {account.amt ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Balance}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Balance Icon"
                                                   />
                                                   {account.amt}
                                                </GridItem>
                                             ) : null}
                                          </Grid>
                                       </Flex>
                                    </Grid>
                                 ) : null}
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, partyBillNoRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="purchase"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <InputField
                                    ref={partyBillNoRef}
                                    type="text"
                                    name="partyNo"
                                    errorName="header.partyNo"
                                    label="Party Bill No"
                                    value={row.header.partyNo}
                                    onChange={(e) => handleInputChange('header', e)}
                                    errors={errors}
                                    onKeyDown={(e) => handleKeyDown(e, partyDateRef, accountRef)}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <InputField
                                    ref={partyDateRef}
                                    type="date"
                                    name="partyDate"
                                    label="Party Bill Date"
                                    value={row.header.partyDate}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, partyBillNoRef)}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       onKeyDown: (e) => {
                                          if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();
                                             supplierRef.current.focus();
                                             // itemRefs?.current[0]?.focus();
                                          }
                                          if (e.key === 'Tab' && e.shiftKey) {
                                             e.preventDefault();
                                             partyDateRef.current.focus();
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       nextRef: issueDocRef,
                                       // onKeyDown: (e) => {
                                       //    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                       //       e.preventDefault();
                                       //       if (issueDocRef.current) {
                                       //          issueDocRef.current.focus();
                                       //       } else if (issueDocRefs.current[0]) {
                                       //          issueDocRefs.current[0].focus();
                                       //       } else if (
                                       //          companyData?.setting?.warehouseWishStock === true &&
                                       //          herderview === true
                                       //       ) {
                                       //          wareHouseRef.current.focus();
                                       //       } else {
                                       //          itemRefs?.current[0]?.focus();
                                       //       }
                                       //    }
                                       // },
                                       onKeyDown: (e) => {
                                          e.preventDefault();
                                          if (daybook?.isAskIncomeExpenses) {
                                             handleKeyDown(e, incomeRef, brokerRef);
                                             return;
                                          }
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             if (e.shiftKey) {
                                                brokerRef?.current?.focus();
                                             } else {
                                                if (
                                                   companyData?.setting?.warehouseWishStock === true &&
                                                   (lineitemview === true || lineDetailview === true)
                                                ) {
                                                   warehouseRef?.current[0]?.focus();
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>

                              {daybook?.isAskIncomeExpenses ? (
                                 <GridItem w="100%">
                                    <AccountSelect
                                       ref={incomeRef}
                                       name="incomeId"
                                       options={accountData}
                                       label="Expenses Account"
                                       value={row.header.incomeId}
                                       errors={errors}
                                       errorName="header.incomeId"
                                       isClearable
                                       isSearchable
                                       onChange={(value) => {
                                          handleAccount('incomeId', value);
                                       }}
                                       onKeyDown={(e) => {
                                          if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();
                                             if (issueDocRef.current) {
                                                issueDocRef.current.focus();
                                             } else if (issueDocRefs.current[0]) {
                                                issueDocRefs.current[0].focus();
                                             } else if (
                                                companyData?.setting?.warehouseWishStock === true &&
                                                herderview === true
                                             ) {
                                                wareHouseRef.current.focus();
                                             } else {
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       }}
                                       showCustomNoOptions={true}
                                       openfrom="salesdaybook"
                                       glGroup={targetGlGroup}
                                    />
                                 </GridItem>
                              ) : null}

                              {daybook && daybook?.issuedaybookid ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'issueDoc',
                                       'Issued Document',
                                       issueDocument.map((x) => ({
                                          label: `${x.itemName} ${x.issued_serial_no ? `(${x.issued_serial_no})` : ''}`,
                                          id: x.issue_linedetail_id,
                                       })),
                                       {
                                          errorName: 'header.issueDoc',
                                          value: issuedDoc,
                                          onChange: (value) => {
                                             setIssuedDoc(value);
                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = issueDocument.filter(
                                                   (data) => data.issue_linedetail_id === value[0],
                                                );
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: issueDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                if (issueDocRefs?.current[0]) {
                                                   issueDocRefs.current[0].focus();
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null}

                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (daybook?.isAskIncomeExpenses) {
                                                      incomeRef?.current?.focus();
                                                   } else {
                                                      supplierRef?.current?.focus();
                                                   }
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}
                           </Grid>

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          companyData?.setting?.warehouseWishStock === true && herderview === true
                                             ? wareHouseRef
                                             : daybook?.isAskIncomeExpenses
                                                ? incomeRef
                                                : supplierRef
                                       }
                                       type="purchase"
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview}
                                       lineDetailview={lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                if (refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs?.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, notesRef, dueDaysRef)}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (
                                                (e.key === 'Enter' && !e.shiftKey) ||
                                                (e.key === 'Tab' && !e.shiftKey)
                                             ) {
                                                e.preventDefault();
                                                paymentRefs?.current[0]?.focus();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                e.preventDefault();
                                                dueDateRef?.current?.focus();
                                             }
                                          }}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      {/* <Th isNumeric>Stock</Th> */}
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      removeDuplicates(selectedStocks, 'serialNo')?.map(
                                                         (item, index) => {
                                                            return (
                                                               <Tr key={index}>
                                                                  <Td>{item?.itemName}</Td>
                                                                  <Td>
                                                                     {item?.serialNo}
                                                                     <Icon
                                                                        as={FaHistory}
                                                                        boxSize={4}
                                                                        ml={3}
                                                                        color="green.600"
                                                                        onClick={() => handleSerialHistory(item)}
                                                                        cursor="pointer"
                                                                     />
                                                                  </Td>
                                                                  {/* <Td isNumeric>{item.pcs}</Td> */}
                                                                  <Td>
                                                                     <IconButton
                                                                        colorScheme="red"
                                                                        size="sm"
                                                                        onClick={() => removeStock(item)}
                                                                        icon={<FaTrash />}
                                                                     />
                                                                  </Td>
                                                               </Tr>
                                                            );
                                                         },
                                                      )}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                          {paymentData?.map((payment, idx) => {
                                             return (
                                                <GridItem w="100%" key={idx}>
                                                   <InputField
                                                      ref={(el) => {
                                                         if (paymentRefs && paymentRefs.current) {
                                                            paymentRefs.current[idx] = el;
                                                         }
                                                      }}
                                                      type="number"
                                                      name={`amount`}
                                                      label={`${payment.daybookName} AMOUNT`}
                                                      value={payment.amount}
                                                      onChange={(e) => handlePaymentOnChange(e, idx)}
                                                      onKeyDown={(e) => {
                                                         if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                         }
                                                         if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }

                                                         if (e.key === 'Tab' && !e.shiftKey) {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }
                                                      }}
                                                      onWheel={(e) => e.target.blur()}
                                                   />
                                                </GridItem>
                                             );
                                          })}
                                       </Grid>
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={filteredDaybooks.find((item) => item.id === row?.header?.daybookId)}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form>
                        <CardFooter justifyContent="flex-end" gap={3}>
                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => handleAskToVerifyCustomer()}
                              isLoading={isLoading}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    // Focus the last paymentRefs element
                                    const lastIndex = paymentRefs?.current?.length - 1;
                                    paymentRefs.current[lastIndex]?.focus();
                                 } else if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 dispatch(emptyPurchase());
                                 handleReset();
                                 navigate('/admin/purchase/invoice');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box>
            </CardBody>
         </Card>

         <SerialNumberModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            selectedDaybook={selectedDaybook}
            handleStock={handleStock}
            itemStocks={itemStocks}
            itemId={lastItemId}
            onCloseComplete={() => {
               setTimeout(() => {
                  if (daybook?.isAllowGstRate && company?.setting?.applyGST && daybook?.applyGst) {
                     gstRateRefs.current[currentIndex]?.focus();
                  } else {
                     rateRefs.current[currentIndex]?.focus();
                  }
               }, 0);
            }}
            setItemStocks={setItemStocks}
            removeStock={removeStock}
            warehouseList={warehouseList}
            lineitemview={lineDetailview}
            selectcompany={companyData}
            textColor={textColor}
            selectdaybookdata={selectdaybookdata}
            lineitem={row.lineItem}
            headerId={id && id > 0 ? id : null}
         />

         <IssueToMill
            isOpen={isOpenIssueToMillModal}
            onClose={onCloseIssueToMillModal}
            daybookData={daybookData}
            brokerData={accountData}
            issueData={issueData}
         />

         <CustomerVerifyModal
            isOpen={isOpenVerifyModal}
            onClose={onCloseVerifyModal}
            accountId={row.header.accountId}
            entryData={salesInvoice}
            handleSubmit={handleSubmit}
            mobile={account?.mobile}
            account={account}
            isLoading={isLoading}
            entryType="purchase"
            invoiceImages={invoiceImages}
            setInvoiceImages={setInvoiceImages}
         />

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Purchase Invoices"
            redirect="/admin/purchase/invoice"
         />

         <TakaForm
            isOpen={isOpenTakaModal}
            onClose={onCloseTakaModal}
            handleTakaDetails={handleTakaDetails}
            currentTakaDetails={currentTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
         />

         <SelectTakaDetail
            isOpen={isOpenTakaDetailModal}
            onClose={onCloseTakaDetailModal}
            takaDetails={takaDetails}
            handleSaveTakaDetail={handleSaveTakaDetail}
            selectedTakaDetails={selectedTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
         />

         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data?.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data?.doc_no}</Td>
                                 <Td>{new Date(data?.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data?.transaction_type}</Td>
                                 <Td>{data?.account_name}</Td>
                                 <Td>{data?.daybook_name}</Td>
                                 <Td>{data?.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0]?.name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>
      </>
   );
};

export default PurchaseInvoiceForm;
